// src/pages/cpaCareerQuiz/components/QuestionCard.jsx
import { motion } from "framer-motion";

export default function QuestionCard({
  question,
  selected,
  onSelect,
  onPrev,
  onNext,
  isFirst,
  isLast,
}) {
  return (
    <motion.fieldset
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      <h4>{question.id}</h4>
      <h3 className="mt-3">{question.text}</h3>

      <div className="mt-4">
        {question.options.map((opt) => (
          <label key={opt.key} className="quiz-option">
            <input
              type="radio"
              name={question.id}
              value={opt.key}
              checked={selected === opt.key}
              onChange={() => onSelect(question.id, opt.key)}
            />
            <span className="quiz-option__text">
              <b>{opt.key}.</b> {opt.text}
            </span>
          </label>
        ))}
      </div>

      <div className="action-buttons mt-5 m-auto">
        <button
          type="button"
          className="action-button previous_button"
          onClick={onPrev}
          disabled={isFirst}
          style={isFirst ? { opacity: 0.5, cursor: "not-allowed" } : undefined}
        >
          上一題
        </button>

        <button
          type="button"
          className="action-button"
          onClick={onNext}
          disabled={!selected}
          style={!selected ? { opacity: 0.5, cursor: "not-allowed" } : undefined}
        >
          {isLast ? "看結果" : "下一題"}
        </button>
      </div>
    </motion.fieldset>
  );
}
